import { RecommendationsState } from '../../../models';
import { RECOMMENDATIONS_MUTATIONS_KEYS } from '../recommendations.const';
import { RecommendationsMutation } from '../recommendations.interfaces';

export class IncreasePageMutation implements RecommendationsMutation {

  mutations = {
    [RECOMMENDATIONS_MUTATIONS_KEYS.increasePage]: (recommendationsState: RecommendationsState) => {
      recommendationsState.page++;
    }
  };

}
